import Resizer from "react-image-file-resizer";

export const resizeFile = (file: File, width: number, height: number) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      width,
      height,
      "jpeg",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "file",
      200,
      200,
    );
  });

const RESIZE_MS = 25_000;

/**
 * Employee detail attachments: `react-image-file-resizer` rejects non-image MIME types
 * (e.g. application/octet-stream) and can hang if the image never decodes. On failure or
 * timeout, returns the original file so upload can still proceed within size limits.
 */
export async function resizeEmployeeAttachment(file: File): Promise<File> {
  try {
    return await new Promise<File>((resolve, reject) => {
      const timer = window.setTimeout(() => {
        reject(new Error("resize-timeout"));
      }, RESIZE_MS);
      try {
        Resizer.imageFileResizer(
          file,
          1000,
          1000,
          "JPEG",
          85,
          0,
          (uri) => {
            window.clearTimeout(timer);
            const out = uri as File;
            if (out instanceof File && out.size > 0) resolve(out);
            else reject(new Error("empty-resize"));
          },
          "file",
          200,
          200,
        );
      } catch (e) {
        window.clearTimeout(timer);
        reject(e instanceof Error ? e : new Error(String(e)));
      }
    });
  } catch {
    return file;
  }
}
